import { CircularProgress, Box, SxProps, Theme } from '@mui/material';
import { forwardRef } from 'react';

type SpinnerProps = {
  size?: number;
  sx?: SxProps<Theme>;
} & Omit<React.HTMLProps<HTMLDivElement>, 'className' | 'size'>;

export const Spinner = forwardRef<HTMLDivElement, SpinnerProps>(
  ({ size = 1, sx, ...rest }, ref) => {
    return (
      <Box
        ref={ref}
        {...rest}
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          ...sx,
        }}
      >
        <CircularProgress
          size={size * 16}
          thickness={4}
          sx={{
            color: 'inherit',
          }}
        />
      </Box>
    );
  }
);

Spinner.displayName = 'Spinner';
